<template>
  <div class="list">
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-2">
          <div class="container-fluid">
            <head-menu-filter
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.filter')"
              :anzahl="anzahlDaten"
              :anzahlAusFilter="anzahlDatenFilter"
            ></head-menu-filter>

            <div class="row mb-2">
              <div
                class="viewfilter block br-t-l-0 br-t-r-0 w-100-p br-t-l-xl-0 br-t-r-xl-0 mt-minus-10"
              >
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.angebotNr"
                        class="form-control input"
                        type="number"
                        placeholder=" "
                        min="0"
                      />
                      <label>{{ $t("global.number") }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>{{ $t("global.from") }}</label>
                      <input
                        v-model="filters.von"
                        type="date"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>{{ $t("global.till") }}</label>
                      <input
                        v-model="filters.bis"
                        type="date"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.status"
                        label="bezeichnung"
                        :options="einsatzstati"
                        :placeholder="$t('global.operationalstatus')"
                        multiple
                        :reduce="(s) => s.id"
                      >
                        <span slot="no-options">{{
                          $t("global.taptosearch")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.operationalstatus") }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <single-select-person
                      id="jugendlicher"
                      :person="filters.jugendlicher"
                      :label="$t('global.youth')"
                      :allowOpen="false"
                      :activeonly="false"
                      editable
                      @confirmed="setFilterJugendlicher"
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <single-select-firma
                      id="einsatzliste-hof"
                      :firma="filters.firma"
                      :editable="true"
                      :allowOpen="true"
                      :label="$t('portal.farm')"
                      @confirmed="setHof"
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <single-select-person
                      id="ansprechsperson"
                      :person="filters.anprechsperson"
                      :label="$t('portal.mainContactPerson')"
                      :allowOpen="false"
                      :activeonly="false"
                      editable
                      @confirmed="setFilterAnsprechsperson"
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.ort"
                        class="form-control input"
                        type="text"
                        :placeholder="$t('global.city')"
                      />
                      <label>{{ $t("global.city") }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.kanton"
                        class="form-control input"
                        type="text"
                        :placeholder="$t('global.canton')"
                      />
                      <label>{{ $t("global.canton") }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.vermittlungsstelle"
                        label="bezeichnung"
                        :options="vermittlungsstellen"
                        :placeholder="$t('global.switchboard')"
                        multiple
                        :reduce="(s) => s.id"
                      >
                        <span slot="no-options">{{
                          $t("global.taptosearch")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.switchboard") }}</label>
                    </div>
                  </div>
                </div>

                <!--<div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.auswahlEinsatzbereich"
                        label="bezeichnung"
                        :options="einsatzbereiche"
                        :placeholder="$t('global.areasofapplication')"
                        multiple
                        :reduce="(s) => s.id"
                      >
                        <span slot="no-options">{{
                            $t("global.taptosearch")
                          }}</span>
                      </v-select>
                      <label>{{ $t("global.areasofapplication") }}</label>
                    </div>
                  </div>
                </div>-->

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>{{ $t("global.reservationDateFrom") }}</label>
                      <input
                        v-model="filters.reservationsDatumVon"
                        type="date"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>{{ $t("global.reservationDateTo") }}</label>
                      <input
                        v-model="filters.reservationsDatumBis"
                        type="date"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12 my-2">
                    <div style="margin-left: 7px">
                      <label
                        class="float-left"
                        style="
                          font-size: 11px !important;
                          font-weight: 700 !important;
                        "
                        >{{ $t("global.manual") }}</label
                      ><input
                        class="form-check-input mx-3"
                        style="margin-top: 0.2rem"
                        v-model="filters.manuell"
                        type="checkbox"
                      />
                    </div>
                  </div>
                </div>

                <filter-search-reset-button />
              </div>
            </div>
          </div>
        </div>

        <div class="col-10">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.deployments')"
              :anzahl="anzahlDaten"
              :anzahlAusFilter="anzahlDatenFilter"
              :gesamtanzahl="gesamtanzahl"
            ></head-menu>
            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0">
                <div class="row d-flex justify-content-between">
                  <div class="ml-4">
                    <button
                      v-if="berechtigungen.b_bildung_anwesenheit.delete"
                      class="btn btn-primary"
                      @click="oeffneAbrechnungModal"
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-file-invoice-dollar"
                        class="mr-2"
                      />
                      Abrechnung
                    </button>
                    <excel-export-modal
                      :class="
                        berechtigungen.b_bildung_anwesenheit.delete
                          ? 'd-inline-block ml-2'
                          : 'd-inline-block'
                      "
                      :filters="queryParams"
                      :config="excelExportConfig"
                    />
                  </div>
                  <div class="mr-4 float-right">
                    <button
                      class="btn btn-danger"
                      @click="oeffneLoeschenModal"
                      v-if="berechtigungen.m_notizen.delete"
                      :disabled="selectedIds.length === 0"
                      :title="
                        selectedIds.length === 0
                          ? $t('global.selectminone')
                          : ''
                      "
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-trash"
                        class="mr-2"
                      />
                      {{ $t("global.delete") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row block belegliste">
              <div class="w-100-p">
                <div>
                  <b-table
                    ref="selectableTable"
                    small
                    tbody-tr-class="item"
                    :items="listData"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    no-local-sorting
                    @sort-changed="onSortChanged"
                    sort-icon-left
                    fixed
                    selectable
                    select-mode="range"
                    @row-dblclicked="details"
                    thead-tr-class="pointer"
                  >
                    <template slot="top-row" slot-scope="{ fields }">
                      <td
                        class="no-pointer"
                        v-for="field in fields"
                        :key="field.key"
                      >
                        <b-input
                          v-if="
                            field.key != 'selected' && field.searchable != false
                          "
                          size="sm"
                          v-model="filters[field.key]"
                          :placeholder="field.label"
                        />
                      </td>
                    </template>

                    <template v-slot:head(selected)="header">
                      <b-form-checkbox
                        ref="headerCheckbox"
                        v-model="header.selected"
                        @input="selectAllRows(header)"
                      ></b-form-checkbox>
                    </template>

                    <template v-slot:cell(selected)="row">
                      <b-form-checkbox
                        v-model="row.item.selected"
                        @input="onRowSelected(row)"
                      ></b-form-checkbox>
                    </template>

                    <template v-slot:cell(reservationsDatum)="row">
                      {{
                        row.item.reservationsDatum
                          ? row.item.reservationsDatum.split(" ")[0]
                          : "-"
                      }}
                    </template>

                    <template v-slot:cell(reservationsZeit)="row">
                      {{
                        row.item.reservationsDatum
                          ? row.item.reservationsDatum.split(" ")[1]
                          : "-"
                      }}
                    </template>

                    <template v-slot:cell(manuell)="row">
                      <font-awesome-icon
                        v-if="row.item.manuell"
                        icon="fa-check"
                      />
                    </template>
                  </b-table>

                  <infinite-loading
                    :identifier="infiniteId"
                    @infinite="(state) => infiniteHandler(state, 'app-api')"
                  >
                    <div slot="spinner">{{ $t("global.loadmoredata") }}</div>
                    <div slot="no-more">{{ $t("global.nofurtherdata") }}</div>
                    <div slot="no-results">
                      {{ $t("global.nofurtherdatafound") }}
                    </div>
                  </infinite-loading>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <abrechnung-modal id="abrechnung-modal" />

    <loeschen-modal
      id="einsatz-loeschen-modal"
      :selectedIds="this.selectedIds"
      :multiple="true"
      @confirmed="einsaetzeLoeschen"
    />

    <loading-overlay v-show="loading"></loading-overlay>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import HeadMenuFilter from "@/components/HeadMenuFilter.vue";
import page from "@/mixins/Page";
import dashboard from "@/mixins/Dashboard";
import filter from "@/mixins/FilterNew";
import store from "@/store";
import SingleSelectFirma from "@/components/global/SingleSelectFirma.vue";
import FilterSearchResetButton from "@/components/Buttons/FilterSearchResetButton.vue";
import HeadMenu from "@/components/HeadMenu.vue";
import LoeschenModal from "@/components/Modals/LoeschenModal.vue";
import AbrechnungModal from "@/components/Modals/AbrechnungModal.vue";
import ExcelExportModal from "@/components/Modals/ExcelExportModal.vue";
import { LADE_AUSWAHLWERTE_CRM } from "@/store/crm/actions.type";
import SingleSelectPerson from "@/components/global/SingleSelectPerson.vue";
import AppApi from "@/api/AppApi";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import { param } from "jquery";

export default {
  name: "Einsatzliste",
  components: {
    SingleSelectPerson,
    LoeschenModal,
    AbrechnungModal,
    ExcelExportModal,
    HeadMenu,
    FilterSearchResetButton,
    SingleSelectFirma,
    Navbar,
    HeadMenuFilter,
  },
  metaInfo() {
    return {
      titleTemplate: () => {
        return "BX: " + this.$t("global.deployments");
      },
    };
  },
  mixins: [page, dashboard, filter],
  props: {},
  store,
  data() {
    return {
      sortBy: null,
      sortDesc: false,
    };
  },
  computed: {
    fields() {
      return [
        { key: "selected", label: "", sortable: false, searchable: false },
        {
          key: "angebotNr",
          label: this.$t("global.num"),
          sortable: true,
          thStyle: { width: "60px" },
          formatter: (value) => {
            if (value) return value; //value.toString().padStart(5, "0");
            return "-";
          },
        },
        {
          key: "von",
          sortable: true,
          searchable: false,
          label: this.$t("global.From"),
          formatter: (value) => {
            if (value) return value;
            return "-";
          },
        },
        {
          key: "bis",
          sortable: true,
          searchable: false,
          label: this.$t("global.till"),
          formatter: (value) => {
            if (value) return value;
            return "-";
          },
        },
        {
          key: "status",
          label: this.$t("global.status"),
          sortable: true,
          searchable: false,
          formatter: (value) => {
            if (value) return value.bezeichnung;
            return "-";
          },
        },
        {
          key: "reservationsDatum",
          label: this.$t("global.reservationDateShort"),
          sortable: true,
          searchable: false,
        },
        {
          key: "reservationsZeit",
          label: this.$t("global.reservationTimeShort"),
          sortable: false,
          searchable: false,
        },
        {
          key: "manuell",
          label: this.$t("global.manual"),
          sortable: true,
          searchable: false,
        },
        {
          key: "jugendlicher",
          label: this.$t("global.youth"),
          sortable: true,
          searchable: false,
          formatter: (value) => {
            if (value)
              return `${value.vorname ? value.vorname : ""} ${
                value.nachname ? value.nachname : ""
              }`;
            return "-";
          },
        },
        {
          key: "hofname",
          label: this.$t("portal.farm"),
          sortable: true,
          searchable: false,
          formatter: (value) => {
            if (value) return value;
            return "-";
          },
        },
        {
          key: "ansprechsperson1",
          label: this.$t("portal.mainContactPerson"),
          sortable: true,
          searchable: false,
          formatter: (value) => {
            if (value)
              return `${value.vorname ? value.vorname : ""} ${
                value.nachname ? value.nachname : ""
              }`;
            return "-";
          },
        },
        {
          key: "ort",
          label: this.$t("global.city"),
          sortable: true,
          formatter: (value) => {
            if (value) return value;
            return "-";
          },
        },
        {
          key: "kanton",
          label: this.$t("global.cantonShort"),
          sortable: true,
          thStyle: { width: "60px" },
          formatter: (value) => {
            if (value) return value;
            return "-";
          },
        },
        {
          key: "vermittlungsstelle",
          label: this.$t("global.switchboardShort"),
          sortable: true,
          searchable: false,
          formatter: (value) => {
            if (value) return value;
            return "-";
          },
        },
        /*{
          key: "aufgabenbereiche",
          sortable: true,
          searchable: false,
          label: this.$t("global.areasofapplication"),
          formatter: (value) => {
            if (value)
              return value;
            return "-";
          }
        },*/
      ];
    },
    queryParams: function () {
      let params = {};

      params.filterAngebotNr = this.setQueryParam(this.filters.angebotNr);
      params.filterVermittlungsstelle = this.setQueryParam(
        this.filters.vermittlungsstelle?.join(",")
      );
      params.filterFirma = this.setQueryParam(this.filters.firma?.id);
      params.filterAnsprechsperson = this.setQueryParam(
        this.filters.ansprechsperson?.id
      );
      params.filterOrt = this.setQueryParam(this.filters.ort);
      params.filterKanton = this.setQueryParam(this.filters.kanton);
      params.filterStatus = this.setQueryParam(this.filters.status?.join(","));
      params.filterEinsatzbereich = this.setQueryParam(
        this.filters.auswahlEinsatzbereich?.join(",")
      );
      //params.filterZeitraumVon = this.setQueryParam(this.filters.von);
      //params.filterZeitraumBis = this.setQueryParam(this.filters.bis);
      params.filterEinsatzVon = this.setQueryParam(this.filters.von);
      params.filterEinsatzBis = this.setQueryParam(this.filters.bis);
      params.filterJugendlicher = this.setQueryParam(
        this.filters.jugendlicher?.id
      );
      params.filterReservationsDatumVon = this.setQueryParam(
        this.filters.reservationsDatumVon
      );
      params.filterReservationsDatumBis = this.setQueryParam(
        this.filters.reservationsDatumBis
          ? this.filters.reservationsDatumBis + " 23:59:59"
          : null
      );
      params.filterManuell = this.setQueryParam(
        this.filters.manuell ? 1 : null
      );

      params.count = this.setQueryParam(
        this.filters.count ? this.filters.count : 50
      );

      params.sortBy = this.sortBy || undefined;
      params.sortDesc = this.sortBy ? this.sortDesc : undefined;

      return params;
    },

    excelExportConfig() {
      return {
        endpoint: "einsatzliste",
        filename: "Einsatzliste",
        stichtag: true,
        stichtagHint: "optional – nur Einsätze, die am gewählten Datum laufen",
        seasonSelect: true,
        seasonFilterKeys: { von: "filterEinsatzVon", bis: "filterEinsatzBis" },
        baseColumns: [
          { key: "angebotNr",          label: this.$t("global.number") },
          { key: "von",                label: this.$t("global.from") },
          { key: "bis",                label: this.$t("global.till") },
          { key: "status",             label: this.$t("global.status") },
          { key: "jugNachname",        label: "JUG Nachname" },
          { key: "jugVorname",         label: "JUG Vorname" },
          { key: "jugOrt",             label: "JUG Wohnort" },
          { key: "jugKanton",          label: "JUG Kanton" },
          { key: "hofname",            label: "Betrieb" },
          { key: "ansprechsperson",    label: this.$t("portal.mainContactPerson") },
          { key: "ort",                label: this.$t("global.city") },
          { key: "kanton",             label: this.$t("global.canton") },
          { key: "vermittlungsstelle", label: this.$t("global.switchboard") },
        ],
        additionalFields: [
          { key: "einsatzdauer_tage",  label: "Einsatzdauer (Tage)" },
          { key: "arbeitstage",        label: "Arbeitstage" },
          { key: "sackgeld",           label: "Sackgeld (CHF)" },
          { key: "sprachregion",       label: "Sprachregion" },
          { key: "schule",             label: "Schule" },
          { key: "istAlpeinsatz",      label: "Alpeinsatz" },
          { key: "nationalitaet",      label: "Nationalität" },
          { key: "herkunft",           label: "Herkunft (Nationalität: Inland/Ausland)" },
          { key: "aufenthaltsstatus",  label: "Aufenthaltsstatus" },
          { key: "alter",              label: "Alter (bei Einsatz)" },
          { key: "geschlecht",         label: "Geschlecht" },
          { key: "jugLand",            label: "JUG Land (Wohnsitz)" },
          { key: "einsatzbereiche",    label: "Aufgabenbereiche (je Wert eine Spalte)" },
        ],
        summaryFields: [
          { key: "per_kanton",                    label: "Einsätze pro Kanton",                    group: "Allgemein" },
          { key: "per_status",                    label: "Einsätze pro Status",                    group: "Allgemein" },
          { key: "per_vs",                        label: "Einsätze pro VS",                        group: "Allgemein" },
          { key: "per_vs_kanton_status",          label: "Einsätze nach VS, Kanton und Status",    group: "Allgemein" },
          { key: "per_betrieb_status",            label: "Einsätze nach Betrieb und Status",       group: "Allgemein" },
          { key: "per_jug_status",                label: "Einsätze nach JUG und Status",           group: "Allgemein" },
          { key: "per_sprachregion",              label: "Einsätze pro Sprachregion",              group: "Jugendliche (JUG)" },
          { key: "per_schule",                    label: "Einsätze pro Schule",                    group: "Jugendliche (JUG)" },
          { key: "alpeinsaetze",                  label: "Alpeinsätze",                            group: "Jugendliche (JUG)" },
          { key: "per_nationalitaet",             label: "JUG nach Nationalität",                  group: "Jugendliche (JUG)" },
          { key: "per_herkunft",                  label: "JUG nach Herkunft (Kanton/Ausland)",        group: "Jugendliche (JUG)" },
          { key: "per_aufenthaltsstatus",         label: "JUG nach Aufenthaltsstatus",             group: "Jugendliche (JUG)" },
          { key: "per_alter",                     label: "JUG nach Alter",                         group: "Jugendliche (JUG)" },
          { key: "per_alter_kanton_nat",          label: "JUG nach Alter, Kanton, Nationalität (Spalte je Kanton)", group: "Jugendliche (JUG)" },
          { key: "per_schule_alter",              label: "JUG nach Schule und Alter",              group: "Jugendliche (JUG)" },
          { key: "alter_avg",                     label: "Alter Durchschnitt",                     group: "Jugendliche (JUG)" },
          { key: "einsatzdauer_total",            label: "Einsatzdauer total",                     group: "Einsatzdauer" },
          { key: "einsatzdauer_avg",              label: "Einsatzdauer Durchschnitt",              group: "Einsatzdauer" },
          { key: "einsatzdauer_per_sprachregion", label: "Einsatzdauer pro Sprachregion (Ø)",      group: "Einsatzdauer" },
          { key: "einsatzdauer_per_kanton",       label: "Einsatzdauer pro Kanton (Ø)",            group: "Einsatzdauer" },
          { key: "einsatzdauer_per_geschlecht",   label: "Einsatzdauer pro Geschlecht (Ø)",        group: "Einsatzdauer" },
          { key: "sackgeld_total",                label: "Sackgeld total",                         group: "Sackgeld" },
          { key: "sackgeld_avg",                  label: "Sackgeld Durchschnitt",                  group: "Sackgeld" },
          { key: "sackgeld_per_alter",            label: "Sackgeld nach Alter (Ø)",                group: "Sackgeld" },
          { key: "sackgeld_per_kanton",           label: "Sackgeld nach Kanton (Ø)",               group: "Sackgeld" },
          { key: "feedback_jug",                  label: "Feedbacks JUG nach Kanton/Sprachregion", group: "Feedbacks" },
          { key: "feedback_bf",                   label: "Feedbacks BF nach Kanton/Sprachregion",  group: "Feedbacks" },
        ],
      };
    },

    //Auswahlwerte
    einsatzbereiche() {
      if (this.$store) return this.$store.state.crm.einsatzbereiche;
      return [];
    },
    vermittlungsstellen() {
      if (this.$store) return this.$store.state.crm.vermittlungsstellen;
      return [];
    },

    einsatzstati() {
      if (this.$store) return this.$store.state.crm.einsatzstati;
      return [];
    },
  },

  created() {
    this.initFilter("einsatzliste", "einsatzliste/", false);
  },

  mounted() {
    if (this.einsatzstati?.length === 0)
      this.$store.dispatch(`crm/${LADE_AUSWAHLWERTE_CRM}`);
  },

  methods: {
    details(einsatz) {
      this.$router.push({
        name: "Einsatz",
        params: { id: einsatz.id },
      });
    },

    setFilterAnsprechsperson(person) {
      this.$set(this.filters, "ansprechsperson", person);
    },

    setFilterJugendlicher(person) {
      this.$set(this.filters, "jugendlicher", person);
    },

    setHof(hof) {
      this.$set(this.filters, "firma", hof);
    },

    oeffneAbrechnungModal() {
      this.$bus.$emit("open-modal", "abrechnung-modal");
    },

    oeffneLoeschenModal() {
      if (this.selectedIds.length > 0)
        this.$bus.$emit("openLoeschenModal", "einsatz-loeschen-modal");
    },

    einsaetzeLoeschen() {
      this.isBusy = true;

      AppApi.delete("einsatzliste/", {
        data: this.selectedIds,
      })
        .then(() => {
          this.$emit("confirmed");
          this.selectedIds = [];
          this.$router.go(0);
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
        })
        .finally(() => {
          this.isBusy = false;
        });
    },

    selectAllRows(row) {
      if (row.selected) {
        this.$refs.selectableTable.items.forEach((item) => {
          item.selected = true;
        });
      } else {
        this.$refs.selectableTable.items.forEach((item) => {
          item.selected = false;
        });
        this.selectedIds = [];
      }
      this.$forceUpdate();
    },

    onRowSelected(row) {
      if (row.item.selected) {
        this.selectedIds.push(row.item.id);
      } else {
        this.selectedIds = this.selectedIds.filter((id) => id !== row.item.id);
      }
    },

    onSortChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.filterValues = this.queryParams;
      this.resetLoading(this);
    },
  },
};
</script>
